import * as React from 'react';
import styled from 'styled-components';
import PromotionalBanner from '@westwing/ui-kit/PromotionalBanner';
import { generateWWEvents } from './WWEvents';
import { useHeaderContext } from 'Components/HeaderContext';

const VisibilityWrapper = styled.div<{ display: CSSDisplay }>`
    display: none; /* This will ensure it won't appear if Club doesn't send anything */
    display: ${({ display }) => display};
`;

export const RaFPromotionalBanner: React.FC<Props> = ({ display }) => {
    const {
        t,
        trackingHelpers: {
            ga: { trackNonInteractiveGenericEvent },
            useCurrentPageType,
        },
    } = useHeaderContext();
    const { pageType } = useCurrentPageType();

    const onClick = React.useCallback(() => {
        const WWEvents = generateWWEvents();
        WWEvents.fire('SIGNUP_OVERLAY_OPEN', { hasSignupVoucher: true, isClosable: true });

        trackNonInteractiveGenericEvent('Promotional header banner', {
            action: 'promotion_header_banner_click',
            label: pageType,
        });
    }, [trackNonInteractiveGenericEvent, pageType]);

    React.useEffect(() => {
        if (display === 'none') {
            return;
        }
        trackNonInteractiveGenericEvent('Promotional header banner', {
            action: 'promo_header_banner_display',
            label: pageType,
        });
    }, [trackNonInteractiveGenericEvent, pageType, display]);

    return (
        <VisibilityWrapper display={display}>
            <PromotionalBanner text={t('OwwHeader_Promotional banner text')} onClick={onClick} />
        </VisibilityWrapper>
    );
};

type Props = {
    display: CSSDisplay;
};

export type CSSDisplay = 'none' | 'block';
